import _get from "lodash.get";

const _getArray = (obj, name) => _get(obj, name) || [];

export default _getArray;
